import React, { useState } from 'react';
import { TextField, Button, Box, Grid, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

const UserDetails = ({ user, onUpdate }) => {
  const [formData, setFormData] = useState({
    username: user.username,
    email: user.email,
    user_group: user.user_group,
    vip_expires_at: user.vip_expires_at ? new Date(user.vip_expires_at).toISOString().slice(0, 16) : '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate({
      ...formData,
      vip_expires_at: formData.vip_expires_at ? new Date(formData.vip_expires_at).toISOString() : null,
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        编辑用户信息
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="username"
            label="用户名"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id="email"
            label="电子邮箱"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="user-group-label">用户组</InputLabel>
            <Select
              labelId="user-group-label"
              id="user_group"
              name="user_group"
              value={formData.user_group}
              onChange={handleInputChange}
            >
              <MenuItem value="admin">管理员</MenuItem>
              <MenuItem value="vip">VIP用户</MenuItem>
              <MenuItem value="regular">普通用户</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="vip_expires_at"
            label="VIP到期时间"
            name="vip_expires_at"
            type="datetime-local"
            value={formData.vip_expires_at}
            onChange={handleInputChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        更新用户信息
      </Button>
    </Box>
  );
};

export default UserDetails;